"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentDragPreview = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var dashboardContexts_1 = require("../../dashboardContexts");
var debug_1 = require("../debug");
function getItemStyles(initialOffset, clientOffset) {
    if (!initialOffset || !clientOffset) {
        return {
            display: "none",
        };
    }
    var x = clientOffset.x, y = clientOffset.y;
    var transform = "translate(" + x + "px, " + y + "px)";
    return {
        transform: transform,
        WebkitTransform: transform,
    };
}
exports.ContentDragPreview = function (props) {
    var itemType = props.itemType, item = props.item, initialOffset = props.initialOffset, clientOffset = props.clientOffset;
    var _a = dashboardContexts_1.useDashboardComponentsContext(), AttributeFilterComponentSet = _a.AttributeFilterComponentSet, InsightWidgetComponentSet = _a.InsightWidgetComponentSet, KpiWidgetComponentSet = _a.KpiWidgetComponentSet;
    var previewComponentsMap = react_1.useMemo(function () { return ({
        attributeFilter: AttributeFilterComponentSet.dragging.DraggingComponent,
        insight: InsightWidgetComponentSet.dragging.DraggingComponent,
        kpi: KpiWidgetComponentSet.dragging.DraggingComponent,
    }); }, [
        AttributeFilterComponentSet.dragging.DraggingComponent,
        InsightWidgetComponentSet.dragging.DraggingComponent,
        KpiWidgetComponentSet.dragging.DraggingComponent,
    ]);
    var component = react_1.useMemo(function () {
        if (!(itemType in previewComponentsMap)) {
            if (debug_1.DEBUG_SHOW_DROP_ZONES) {
                console.warn("DND: dnd item " + itemType + " not handled by CustomDragLayer");
            }
            return null;
        }
        var Component = previewComponentsMap[itemType];
        return react_1.default.createElement(Component, { itemType: itemType, item: item });
    }, [itemType, previewComponentsMap, item]);
    return (react_1.default.createElement("div", { className: "drag-preview", style: getItemStyles(initialOffset, clientOffset) }, component));
};
//# sourceMappingURL=ContentDragPreview.js.map